import { Card } from '@cimpress/react-components';
import { ChildComponentRenderer } from './renderers';
import type { PreviewCardProps } from './types';
import classes from './Preview3DCard.module.css';

export const Preview3DCard = ({ title, loader, onAgsMetadataLoaded }: PreviewCardProps<'preview3d'>) => {
    return (
        <Card className={classes.card3d} isMinimal header={title}>
            <ChildComponentRenderer loader={loader} onAgsMetadataLoaded={onAgsMetadataLoaded} />
        </Card>
    );
};
